// Module
var code = "<li> <label> <input type=radio name=countryInput class=countryInput value=\"<%- value %>\" data-country=\"<%- text %>\" style=appearance:radio;-moz-appearance:radio;-webkit-appearance:radio> <%- text %> </label> </li> ";
// Exports
module.exports = code;